import React from "react";

function ESIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <g clipPath="url(#clip0_47_205)">
        <path
          fill="#FFDA44"
          d="M0 9c0 1.1.198 2.155.56 3.13l8.44.783 8.44-.783A8.98 8.98 0 0018 9a8.98 8.98 0 00-.56-3.13L9 5.087.56 5.87A8.98 8.98 0 000 9z"
        ></path>
        <path
          fill="#D80027"
          d="M17.44 5.87a9.003 9.003 0 00-16.88 0h16.88zM.56 12.13a9.003 9.003 0 0016.88 0H.56z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_47_205">
          <path fill="#fff" d="M0 0H18V18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(ESIcon);
